import { PropsWithChildren } from "react";
import { FormProvider, useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import {
	customColorModalSchema,
	SelectCustomColorModalSchema
} from "components/NewOrders/SelectCustomColorModal/SelectCustomColorModalSchema.ts";

interface SelectCustomColorModalFormProviderProps extends PropsWithChildren {
	defaultValues?: SelectCustomColorModalSchema;
	noFinishesAvailable: boolean;
}

const SelectCustomColorModalFormProvider = ({
	children,
	defaultValues,
	noFinishesAvailable
}: SelectCustomColorModalFormProviderProps) => {
	const formMethods = useForm({
		mode: "onSubmit",
		resolver: yupResolver(customColorModalSchema),
		reValidateMode: "onChange",
		defaultValues: defaultValues ?? { finishes: null },
		context: { hasFinishes: !noFinishesAvailable } // <-- Only here!
	});

	return <FormProvider {...formMethods}>{children}</FormProvider>;
};

export default SelectCustomColorModalFormProvider;
